export var AlertGranularity;
(function (AlertGranularity) {
    AlertGranularity["Realtime"] = "realtime";
    AlertGranularity["Hour"] = "hour";
    AlertGranularity["Day"] = "day";
    AlertGranularity["Week"] = "week";
})(AlertGranularity || (AlertGranularity = {}));
//# sourceMappingURL=alert.granularity.js.map